import * as React from 'react';
import { useEffect, useState } from "react";
import { Box, Typography, Chip, CircularProgress } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import ErrorIcon from "@mui/icons-material/Error";
import "../../../styles/rosterSummary.css";
import {api} from "../../../../../utils/axios";

interface Props {
    clientId: string;
}

const RosterSummary = ({ clientId }: Props) => {

    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        const fetchSummary = async () => {
            setLoading(true);
            try {
                const res = await api.get(`/client/employee-plan-summary?client_id=${clientId}`);
                setData(res.data);
            } catch (err) {
                console.error("Error loading roster summary", err);
            } finally {
                setLoading(false);
            }
        };
        fetchSummary();
    }, [clientId]);

    if (loading || !data) return <CircularProgress />;

    return (
        <Box className="roster-summary-container">
            <Typography variant="h5" gutterBottom>
                Roster Summary for {data.client_name}
            </Typography>

            <Typography variant="subtitle1" gutterBottom>
                Total distinct employees: <strong>{data.employee_count}</strong>
            </Typography>

            <Box className="plan-section">
                <Typography variant="subtitle2">Client Customer Plans</Typography>
                <ul>
                    {data.client_customer_plans.map((plan: string) => (
                        <li key={plan}>{plan}</li>
                    ))}
                </ul>
            </Box>

            <Box className="plan-section">
                <Typography variant="subtitle2">Reference Customer Plans</Typography>
                <ul>
                    {data.reference_customer_plans.map((plan: string) => (
                        <li key={plan}>{plan}</li>
                    ))}
                </ul>
            </Box>

            <Box mt={3}>
                <Typography variant="h6" gutterBottom>Validations</Typography>

                <Box className="validation-item">
                    {data.unmatched_client_plans.length === 0 ? (
                        <Chip color="success" icon={<CheckCircleIcon />} label="All client plans match reference plans" />
                    ) : (
                        <>
                            <Chip color="error" icon={<ErrorIcon />} label="Unmatched client plans found" />
                            <ul className="unmatched-list">
                                {data.unmatched_client_plans.map((plan: string) => (
                                    <li key={plan}>{plan}</li>
                                ))}
                            </ul>
                        </>
                    )}
                </Box>

                <Box className="validation-item">
                    {data.has_duplicates ? (
                        <Chip color="error" icon={<ErrorIcon />} label="Duplicate email/phone entries found" />
                    ) : (
                        <Chip color="success" icon={<CheckCircleIcon />} label="No duplicates found" />
                    )}
                </Box>
            </Box>
        </Box>
    );
};

export default RosterSummary;
